import { createContext } from "react";

import { type StatusPopupContextType } from "./types";

export const StatusPopupContext = createContext<
  StatusPopupContextType | undefined
>(undefined);
